export enum PATH {
  HOME_PAGE = '/',
  PLAN_EXECUTION = '/plan-execution',
  PLAN_LIST = '/plan-list',
  ANNOUNCEMENTS = '/announcements',
  CHANGE_PASSWORD = '/changePassword',
  CONTROL_PLAN = '/control-plan',
  LOGOUT = '/logout',
  IMBALANCE_PRICES="imbalance-prices",
  TODO = '/to-do',
  SITES_NOT_ELIGIBLE_FOR_BIDDING = '/sites-not-eligible-for-bidding',
  SITE_INFORMATION = '/site-information',
  TRANSACTION_RESULTS = '/transaction-results',
}
export interface Navigation {
  _tag: string;
  name?: string;
  className?: string;
  to?: PATH;
  icon?: string;
  service_id?: string;
}
const navigation_ja: Navigation[] = [
  {
    _tag: 'CSidebarNavItem',
    name: 'TODO',
    to: PATH.TODO,
    icon: 'cil-task',
    service_id: 'todo'
  },
  {
    _tag: 'CSidebarNavItem',
    name: '計画一覧',
    to: PATH.PLAN_LIST,
    icon: 'cil-list',
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'インバランス予測単価',
    to: PATH.IMBALANCE_PRICES,
    icon: 'cil-bolt',
    service_id: 'imbalance_prices'
  },

  {
    _tag: 'CSidebarNavItem',
    name: 'サイト情報',
    to: PATH.SITE_INFORMATION,
    icon: 'cil-notes',
    service_id: 'site_info'
  },
  {
    _tag: 'CSidebarNavItem',
    name: '取引実績取得',
    to: PATH.TRANSACTION_RESULTS,
    icon: 'cil-cloud-download',
    service_id: 'transaction_results'
  },
  {
    _tag: 'CSidebarNavItem',
    name: '入札対象外サイト指定',
    to: PATH.SITES_NOT_ELIGIBLE_FOR_BIDDING,
    icon: 'cil-ban',
    service_id: 'not_available_periods'
  },

  {
    _tag: 'CSidebarNavDivider',
    className: 'sed-om-sidebar-divider mt-auto',
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'パスワード変更',
    to: PATH.CHANGE_PASSWORD,
    icon: 'cil-user',
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'ログアウト',
    to: PATH.LOGOUT,
    icon: 'cil-account-logout',
  },
  {
    _tag: 'CSidebarNavDivider',
    className: 'm-2',
  },
];
export default navigation_ja;
